import { useMutation } from '@tanstack/react-query';
import { saveUserPreferences } from '../services/fn-api/User';

interface UserPreferenceModel {
    dateFormat: string;
  }

export const useSaveUserPreferences = () => {
  return useMutation<void, Error, UserPreferenceModel>({
    mutationFn: async ( preferences: UserPreferenceModel) => {
      return saveUserPreferences(preferences);
    },
  });
};
